import {
  GoogleGenAI,
} from "@google/genai";

const MODEL_NAME = "gemini-2.5-flash-lite";
const API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

export const getParagraphFromGemini = async (): Promise<string> => {
  const ai = new GoogleGenAI({ apiKey: API_KEY });

  const response = await ai.models.generateContent({
    model: MODEL_NAME,
    contents: "give me a random paragraph with 100 words that is unique everytime"
  });

  return response.text ?? "";
};
